import { Button, Form, Col, InputGroup, Row, Container } from "react-bootstrap";
import React, {useEffect, useState} from 'react';
import axios from "axios";
import { endpoint } from "../utils/api";
import { getZoomValue } from "../utils/checkUser";

export const Zoom = () => {

    const [zoom, setZoom] = useState();
    
    const decrement = () => {
        if(zoom > 70){
            setZoom(zoom-5);
        }
    }
    const increment = () => {
        if(zoom < 110){
            setZoom(zoom+5);
        }
    }

    useEffect (() => {
        getZoomValue(setZoom)
    },[])
    useEffect (() => {
        if(zoom !== undefined) {
            let zoomString = zoom.toString() + "%";    
            document.documentElement.style.setProperty('--zoom-level',zoomString)
        }     
      }, [zoom])
    
    useEffect(() => {
        if (localStorage.token !== undefined && zoom !== undefined) {
         axios({
                method: "put",
                url: `${endpoint}/users/zoom`, 
                data: {
                    zoom_value: zoom
                } ,
                headers: {
                    Authorization: 'Bearer '+ localStorage.token
                }
            })
                .then(function (response) {
            if (response.status === 200) {
       
            } else {
                console.log(response.statusText);
                console.log(response.errors);
            }
            })
            .catch((error) => {
            console.log(error);
            });
        }
    }, [zoom])
   

    return (
        <Container className="zoom-container">
        <Row className="zoom-row">
            <Col className="zoom-decrement-col">
            <Button variant="outline-secondary" className="zoom-button-decrement" onClick={decrement}>-</Button>
            </Col>
            <Form.Group as={Col} className="zoom-col">
                <InputGroup className="mb-3 zoom-box">
                  <Form.Control name="zoom_value" className="zoom-control" id="zoom_value" value={zoom + "%"}/>               
                </InputGroup>
              </Form.Group>

            <Col className="zoom-increment-col">            
            <Button variant="outline-secondary" className="zoom-button" onClick={increment}>+</Button>
            </Col>
        </Row>
        </Container>

    
    )
}


